import { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AppContext } from './AppContext';
import { REDIRECT_URI, ROUTES } from './common/constants';

const EXCLUDED_ROUTES = [
  ROUTES?.LOGIN,
  ROUTES?.LOGOUT,
  ROUTES?.SIGNUP,
  ROUTES?.FORGET_PASSWORD,
  ROUTES?.RESET,
  ROUTES?.VERIFY,
];

const shouldSaveRedirect = (pathname) => {
  if (
    EXCLUDED_ROUTES.some(
      (route) => pathname === route || pathname?.startsWith(route),
    )
  ) {
    return false;
  }
  if (pathname === ROUTES?.LOGIN) {
    return false;
  }

  return true;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { getToken } = useContext(AppContext);
  const idToken = getToken();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!idToken) {
          const { pathname, search } = props.location;
          if (shouldSaveRedirect(pathname)) {
            const redirectUrl = pathname + search;
            // eslint-disable-next-line no-undef
            sessionStorage.setItem(REDIRECT_URI, redirectUrl);
          } else {
            // eslint-disable-next-line no-undef
            sessionStorage.removeItem(REDIRECT_URI);
          }

          return <Redirect to={ROUTES?.LOGIN} />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
